export default __webpack_public_path__ + "static/char-sp03-anr-1a0750677609cfcc24115f7dafcd5629.webp";